import Swal from 'sweetalert2';

/**
 * Tabulação de encerramento do atendimento (WhatsApp).
 *
 * Exibida ao finalizar a tratativa do operador. Registra o resultado do
 * atendimento ("Alugou?") e, quando negativo, o motivo que impediu o
 * fechamento da locação.
 */
export const MOTIVOS_NAO_LOCACAO = [
	'Possui contrato ativo conosco',
	'Apenas pesquisando',
	'Preço',
	'Modelo/Categoria',
	'Localização de retirada',
	'Perfil do cliente',
	'Data de retirada'
];

// Valor da opção que libera o campo livre. Não é um motivo em si: o que vai
// para o banco é o texto digitado pelo operador.
export const MOTIVO_OUTROS = 'Outros';

// Mesmo limite da coluna `motivo_nao_locacao` em at_clients_attendance.
export const MOTIVO_MAX_LENGTH = 100;

const buildHtml = () => {
	const options = MOTIVOS_NAO_LOCACAO
		.map(motivo => `<option value="${motivo}">${motivo}</option>`)
		.join('');

	return `
		<div id="tabulacaoEncerramento" style="text-align: left">
			<p style="margin-bottom: 10px">Deseja finalizar o atendimento?</p>

			<label for="tabAlugou" style="font-weight: bold; margin-bottom: 4px">Alugou?</label>
			<select id="tabAlugou" class="swal2-select" style="display: flex; width: 100%; margin: 0 0 10px 0">
				<option value="">Selecione</option>
				<option value="Sim">Sim</option>
				<option value="Nao">Não</option>
			</select>

			<div id="tabMotivoGroup" hidden>
				<label for="tabMotivo" style="font-weight: bold; margin-bottom: 4px">Motivo da não locação</label>
				<select id="tabMotivo" class="swal2-select" style="display: flex; width: 100%; margin: 0">
					<option value="">Selecione</option>
					${options}
					<option value="${MOTIVO_OUTROS}">${MOTIVO_OUTROS}</option>
				</select>

				<div id="tabMotivoOutrosGroup" hidden style="margin-top: 10px">
					<label for="tabMotivoOutros" style="font-weight: bold; margin-bottom: 4px">Descreva o motivo</label>
					<input
						id="tabMotivoOutros"
						type="text"
						class="swal2-input"
						maxlength="${MOTIVO_MAX_LENGTH}"
						placeholder="Informe o motivo da não locação"
						style="display: flex; width: 100%; margin: 0">
				</div>
			</div>
		</div>
	`;
};

/**
 * Abre o modal de tabulação.
 *
 * @returns {Promise<{alugou: string, motivo_nao_locacao: string|null}|null>}
 *          Os dados tabulados ou `null` caso o operador cancele a finalização.
 */
export const tabulacaoEncerramento = () => {
	return Swal.fire({
		title: 'Finalizar atendimento',
		html: buildHtml(),
		type: 'warning',
		showCancelButton: true,
		confirmButtonColor: '#DD6B55',
		confirmButtonText: 'Finalizar',
		cancelButtonText: 'Cancelar',
		focusConfirm: false,
		allowOutsideClick: false,
		onOpen: () => {
			const alugou = document.getElementById('tabAlugou');
			const motivoGroup = document.getElementById('tabMotivoGroup');
			const motivo = document.getElementById('tabMotivo');
			const outrosGroup = document.getElementById('tabMotivoOutrosGroup');
			const outros = document.getElementById('tabMotivoOutros');

			const toggleOutros = () => {
				const isOutros = motivo.value === MOTIVO_OUTROS;

				outrosGroup.hidden = !isOutros;

				if (!isOutros) {
					outros.value = '';
					return;
				}

				outros.focus();
			};

			alugou.addEventListener('change', () => {
				const naoAlugou = alugou.value === 'Nao';

				motivoGroup.hidden = !naoAlugou;

				if (!naoAlugou) {
					motivo.value = '';
				}

				toggleOutros();
			});

			motivo.addEventListener('change', toggleOutros);
		},
		preConfirm: () => {
			const alugou = document.getElementById('tabAlugou').value;
			const motivo = document.getElementById('tabMotivo').value;
			const outros = document.getElementById('tabMotivoOutros').value.trim();

			if (!alugou) {
				Swal.showValidationMessage('Informe se o cliente alugou.');
				return false;
			}

			if (alugou !== 'Nao') {
				return { alugou, motivo_nao_locacao: null };
			}

			if (!motivo) {
				Swal.showValidationMessage('Informe o motivo da não locação.');
				return false;
			}

			// Em "Outros" o texto digitado é o motivo gravado; o relatório
			// agrupa tudo que está fora da lista padrão sob "Outros".
			if (motivo === MOTIVO_OUTROS) {
				if (!outros) {
					Swal.showValidationMessage('Descreva o motivo da não locação.');
					return false;
				}

				return {
					alugou,
					motivo_nao_locacao: outros.slice(0, MOTIVO_MAX_LENGTH)
				};
			}

			return { alugou, motivo_nao_locacao: motivo };
		}
	}).then(result => (result.value ? result.value : null));
};

export default tabulacaoEncerramento;
